import React, { useEffect, useRef, useState } from "react";

import { Content, SwitchContainer, TableSection } from "./styled";
import { Header } from "../../components/Header";

import api from "../../api/axios";
import { Button } from "@mui/material";
import { Table } from "../../components/Table";
import { toast } from "react-toastify";
import { OportunityTable } from "../../components/OportunityContainer";
import FullScreenLoader from "../../components/FullScreenLoader";

const Admin = () => {
  const [tableData, setTableData] = useState([]);
  const [table, setTable] = useState(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (savedState) {
      try {
        const state = JSON.parse(savedState);

        return state.selectedTable || "professional";
      } catch (error) {
        return "professional";
      }
    }

    return "professional";
  });

  const [isLoading, setIsLoading] = useState(true);

  const [professionalData, setProfessionalData] = useState(null);
  const [cooperativeData, setCooperativeData] = useState(null);
  const [skillData, setSkillData] = useState(null);
  const [oportunityData, setOportunityData] = useState(null);

  const tableSectionRef = useRef(null);

  const getData = async (type) => {
    try {
      const res = await api.get(`/${type}/list`);

      if (type === "professional") {
        setTable(type);
        setProfessionalData(res.data);
      } else if (type === "cooperative") {
        setTable(type);
        setCooperativeData(res.data);
      } else if (type === "skill") {
        setTable(type);
        setSkillData(res.data);
      } else if (type === "oportunity") {
        setTable(type);
        setOportunityData(res.data);
      }

      setTableData(res.data);
      setIsLoading(false);
    } catch (error) {
      toast.error(error);
    }
  };

  // ----------------- FAZER COM QUE AO MUDAR O TIPO, JÁ SALVAR NO STATE -----------------

  const handleProfessionalClick = () => {
    if (table !== "professional") setIsLoading(true);
    setTable("professional");
  };

  const handleCooperativeClick = () => {
    if (table !== "cooperative") setIsLoading(true);
    setTable("cooperative");
  };

  const handleSkillsClick = () => {
    if (table !== "skill") setIsLoading(true);
    setTable("skill");
  };

  const handleOportunityClick = () => {
    if (table !== "oportunity") setIsLoading(true);
    setTable("oportunity");
  };

  useEffect(() => {
    if (table === "professional") {
      if (professionalData) {
        setTableData(professionalData);
        setIsLoading(false);
      } else {
        getData("professional");
      }
    } else if (table === "cooperative") {
      if (cooperativeData) {
        setTableData(cooperativeData);
        setIsLoading(false);
      } else {
        getData("cooperative");
      }
    } else if (table === "skill") {
      if (skillData) {
        setTableData(skillData);
        setIsLoading(false);
      } else {
        getData("skill");
      }
    } else if (table === "oportunity") {
      if (oportunityData) {
        setTableData(oportunityData);
        setIsLoading(false);
      } else {
        getData("oportunity");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table]);

  return (
    <Content>
      <FullScreenLoader fadeOut={!isLoading} />
      <Header />
      <TableSection ref={tableSectionRef}>
        <SwitchContainer>
          <Button
            onClick={handleProfessionalClick}
            variant="text"
            sx={{
              color: "#104467",
              fontWeight: 600,
              backgroundColor:
                table === "professional" ? "rgba(8, 31, 46, 0.1)" : "none",
            }}
            disabled={isLoading}
          >
            Profissionais
          </Button>
          <Button
            onClick={handleCooperativeClick}
            variant="text"
            sx={{
              color: "#104467",
              fontWeight: 600,
              backgroundColor:
                table === "cooperative" ? "rgba(8, 31, 46, 0.1)" : "none",
            }}
            disabled={isLoading}
          >
            Cooperados
          </Button>
          <Button
            onClick={handleSkillsClick}
            variant="text"
            sx={{
              color: "#104467",
              fontWeight: 600,
              backgroundColor:
                table === "skill" ? "rgba(8, 31, 46, 0.1)" : "none",
            }}
            disabled={isLoading}
          >
            Habilidades
          </Button>
          <Button
            onClick={handleOportunityClick}
            variant="text"
            sx={{
              color: "#104467",
              fontWeight: 600,
              backgroundColor:
                table === "oportunity" ? "rgba(8, 31, 46, 0.1)" : "none",
            }}
            disabled={isLoading}
          >
            Oportunidades
          </Button>
        </SwitchContainer>
        {table !== "oportunity" ? (
          <Table
            tableSectionRef={tableSectionRef}
            professionalData={professionalData}
            tableData={tableData}
            setTableData={setTableData}
            tableType={table}
            setTableType={setTable}
            getData={getData}
          />
        ) : (
          <OportunityTable tableData={tableData} getData={getData} />
        )}
      </TableSection>
    </Content>
  );
};

export default Admin;
